<template>
  <div class="APIHomepage_more_detail">
    <div class="more-table-in">
      <div class="detail-breadcrumb">
        <span>
          Data Library / API Documentation /
          <span class="fromitem">{{apiName}}</span>
        </span>
      </div>
      <div class="more-info-block">
        <div class="info-title">Basic Information</div>
        <div class="info-content">
          <!-- <div class="info-list-flex">
            <div class="info-list-title">Affiliated Enterprise:</div>
            <div class="info-list-desc">API Data Service Co., Ltd.</div>
          </div> -->
          <div class="info-list-flex">
            <div class="info-list-title">API ID:</div>
            <div class="info-list-desc">{{ apiInfo.apiDataApiId || "--" }}</div>
          </div>
          <!-- <div class="info-list-flex">
            <div class="info-list-title">Data Provider:</div>
            <div class="info-list-desc">
              National Enterprise Credit Information Publicity System
            </div>
          </div> -->
          <div class="info-list-flex">
            <div class="info-list-title">Call Success Rate:</div>
            <div class="info-list-desc">
              {{ successRationStr || "--%" }}
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Update Time:</div>
            <div class="info-list-desc">
              {{
                $formatDateTime(apiInfo.updateTime, "yyyy-MM-dd hh:mm:ss") ||
                "--"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Technical Information</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title">API Endpoint:</div>
            <div class="info-list-desc">{{ apiInfo.apiUrl || "--" }}</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Request Method:</div>
            <div class="info-list-desc">
              {{ apiInfo.requestMethod || "--" }}
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">Request Parameters:</div>
          </div>
          <div class="info-content">
            <div class="info-desc"></div>
            <div class="bulkData-completed-table">
              <el-table
                ref="multipleTable"
                :data="requestParamsData"
                tooltip-effect="dark"
                style="width: 100%"
              >
                <el-table-column
                  prop="filedName"
                  label="Filed"
                  width="250"
                ></el-table-column>
                <el-table-column prop="filedType" label="Type" width="200">
                </el-table-column>
                <el-table-column
                  prop="required"
                  label="Required"
                  width="200"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="example"
                  label="Example"
                ></el-table-column>
                <el-table-column prop="note" label="Note"></el-table-column>
              </el-table>
            </div>
            <!-- </div> -->
          </div>
          <div class="info-list-flex">
            <div class="info-list-title fontsize18">RequestBody:</div>
          </div>
          <div class="info-list-desc-content fontsize18">
            <pre>{{ formattedJson(apiInfo.requestBody) }}</pre>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title fontsize18">Return Parameter:</div>
          </div>
          <div class="info-list-desc-content fontsize18">
            <pre>{{ formattedJson(apiInfo.responseBody) }}</pre>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Status Code Description</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title">true</div>
            <div class="info-list-desc">Success</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">false</div>
            <div class="info-list-desc">Failed</div>
          </div>
          <!-- <div class="info-list-flex">
            <div class="info-list-title">200</div>
            <div class="info-list-desc">Request successful</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">400</div>
            <div class="info-list-desc">Parameter error</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">401</div>
            <div class="info-list-desc">
              Unauthorized / signature error
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">403</div>
            <div class="info-list-desc">Insufficient permissions</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">404</div>
            <div class="info-list-desc">Enterprise information does not exist</div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title">500</div>
            <div class="info-list-desc">Internal server error</div>
          </div> -->
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Example Code (Java)</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title fontsize18">Production use only (Java):</div>
          </div>
          <div class="info-list-desc-content fontsize18">
            <pre>{{ apiInfo.javaExampleCode ||'null'}}</pre>
          </div>
        </div>
      </div>
      <div class="more-info-block">
        <div class="info-title">Development Resources</div>
        <div class="info-content">
          <div class="info-list-flex">
            <div class="info-list-title linkCss" @click="downloadClick('pdf')">
              Download API Doc(PDF)
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title linkCss" @click="downloadClick('word')">
              Download API Doc(Word)
            </div>
          </div>
          <div class="info-list-flex">
            <div class="info-list-title linkCss" @click="downloadClick('enum')">
              Value Dictionary
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <!-- <el-button @click="applyforTest()" class="applyAccountBtn"
          >Apply Test Account</el-button
        > -->
        <!-- <el-button type="primary" @click="centerDialogVisible = false"
          >Subscription</el-button
        > -->
      </div>
    </div>
    <!-- 申请测试 -->
    <!-- <ApplyForTestDialogVue
      :applyDialogVisible="applyDialogVisible"
      :applyfortestForm="applyfortestForm"
      @getAPPKey="getAPPKey"
      @getSecretKey="getSecretKey"
      @closeApplyforTestVisible="closeApplyforTestVisible"
      @toGenerateClick="toGenerateClick"
    ></ApplyForTestDialogVue> -->
  </div>
</template>

<script>
import {
  getApiDataApiItemById,
  downLoadFileByItemId,
  generateAppKeyInfo,
  applyAccount,
} from "@/api/dataServicesApi";
import { downloadFromBase64 } from "@/utils/date";
// import ApplyForTestDialogVue from "../components/applyForTestDialog.vue";
import crypto from "@/utils/crypto";
export default {
  props: [],
  data() {
    return {
      apiName: "", //二级名称
      categoryName: "", //一级名称
      apiInfo: {},
      requestParamsData: [],
      requestBody: {},
      applyDialogVisible: false,
      successRationStr:'',
      // applyfortestForm: {
      //   appKey: "",
      //   secretKey: "",
      //   createTime: "",
      //   days: "",
      //   callCount: "",
      // },
    };
  },
  components: {
    // ApplyForTestDialogVue,
  },
  computed: {},
  watch: {},
  created() {
    this.getApiDataApiItemByIdList();
    this.successRationStr = this.$route.query.successRationStr; //成功率
  },
  mounted() {},
  methods: {
    // 获取详情数据
    async getApiDataApiItemByIdList() {
      this.id = this.$route.query.id; //二级分类id
      let res = await getApiDataApiItemById(`?id=${this.id}`);
      console.log("res---", res, res.code);
      if (res.code == 200) {
        this.apiInfo = JSON.parse(JSON.stringify(res.data));
        this.apiName = this.apiInfo.apiName;
        this.requestParamsData = JSON.parse(this.apiInfo.requestParams);
        this.requestBody =this.apiInfo.requestBody;
        console.log("this.apiInfo", this.apiInfo,this.apiInfo.responseBody);
      } else {
        this.$message.error(res.msg);
      }
    },
    // 展示json对象
    formattedJson(data) {
      try {
        let obj = JSON.parse(data);
        return JSON.stringify(obj, null, 2); // 2 个空格缩进
      } catch (e) {
        console.log('e',e);
        return "Invalid JSON";
      }
    },
    // 下载
    downloadClick(type) {
      let params = {
        apiItemId: this.apiInfo.id,
        fileType: type,
      };
      if (type == "pdf") {
        downLoadFileByItemId(params).then((res) => {
          if (res.code == 200) {
            // 截取文件后缀名 查看属于什么文件
            let fileType = res.msg.split(".").pop().toLowerCase();
            var downloadType = "";
            if (fileType == "pdf") {
              downloadType = "application/pdf";
            }
            downloadFromBase64(res.data, downloadType, res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (type == "word") {
        downLoadFileByItemId(params).then((res) => {
          if (res.code == 200) {
            // 截取文件后缀名 查看属于什么文件
            let fileType = res.msg.split(".").pop().toLowerCase();
            var downloadType = "";
            if (fileType == "docx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            } else if (fileType == "doc") {
              downloadType = "application/msword";
            }
            downloadFromBase64(res.data, downloadType, res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      } else if (type == "enum") {
        // 类型为enum 下载的文件类型可能是xls xlsx csv  doc pdf
        downLoadFileByItemId(params).then((res) => {
          if (res.code == 200) {
            // 截取文件后缀名 查看属于什么文件
            let fileType = res.msg.split(".").pop().toLowerCase();
            var downloadType = "";
            if (fileType == "pdf") {
              downloadType = "application/pdf";
            } else if (fileType == "docx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
            } else if (fileType == "doc") {
              downloadType = "application/msword";
            } else if (fileType == "xls") {
              downloadType = "application/vnd.ms-excel";
            } else if (fileType == "xlsx") {
              downloadType =
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
            } else if (fileType == "csv") {
              downloadType = "text/csv;charset=utf-8";
            }
            downloadFromBase64(res.data, downloadType, res.msg);
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    // // 申请
    // async applyforTest() {
    //   // 获取账号信息
    //   await generateAppKeyInfo().then((res) => {
    //     if (res.code == 200) {
    //       let generateAppKeyInfo = JSON.parse(JSON.stringify(res.data));
    //       // 解密密码
    //       generateAppKeyInfo.secretKey = crypto.decrypt(
    //         generateAppKeyInfo.secretKey
    //       );
    //       this.applyDialogVisible = true;
    //       this.applyfortestForm = JSON.parse(
    //         JSON.stringify(generateAppKeyInfo)
    //       );
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    // copy appkey secretKey
    // async getAPPKey() {
    //   this.copyTool(this.applyfortestForm.appKey);
    // },
    // getSecretKey() {
    //   this.copyTool(this.applyfortestForm.secretKey);
    // },
    // async copyTool(data) {
    //   try {
    //     await this.$copyText(data);
    //     this.$message({
    //       message: "Copied",
    //       type: "success",
    //     });
    //   } catch (err) {
    //     this.$message({
    //       message: "Failed to copy: " + err,
    //       type: "warning",
    //     });
    //   }
    // },
    // closeApplyforTestVisible() {
    //   this.applyDialogVisible = false;
    //   this.applyfortestForm = {
    //     appKey: "",
    //     secretKey: "",
    //     createTime: "",
    //     days: "",
    //     callCount: "",
    //   };
    // },
    // // 生成(单一生成当前列数据的测试账号)
    // async toGenerateClick() {
    //   try {
    //     console.log("点击了");
    //     let apiIdArr = [this.id];
    //     let params2 = {
    //       appKey: this.applyfortestForm.appKey,
    //       apiId: apiIdArr, //二级的分类id
    //       env: 1, //1是测试2是生产
    //     };
    //     let res2 = await applyAccount(params2);
    //     if (res2.code == 200) {
    //       this.$message.success(res2.msg);
    //     } else {
    //       this.$message.error(res2.msg);
    //     }
    //     this.closeApplyforTestVisible();
    //   } catch (error) {
    //     console.log("error", error);
    //   }
    // },
  },
};
</script>

<style scoped>
@import '../../../assets/css/DataApiDetail.css';
</style>
